import { ClassNameProps, Item } from '../../../types/types';
import { startedItems } from '../../../data/data';
const ListStarted: React.FC<ClassNameProps> = ({ className }) => {
  return (
    <>
      <ul className={className}>
        {startedItems.map((item: Item) => (
          <li key={item.id} className={`${className}__item`}>
            {item.img && (
              <img
                src={item.img}
                className={`${className}__img`}
                alt={item.title}
              />
            )}
            {item.svg && <>{item.svg}</>}
            <div className={`${className}__inner`}>
              <h3 className={`${className}__title subtitle`}>{item.title}</h3>
              <p className={`${className}__text text-normal`}>{item.text}</p>
            </div>
          </li>
        ))}
      </ul>
      <p className={`${className}__text text-large`}>
        We can help you integrate and launch our services within two weeks of
        your initial contact, empowering your international business to expand.
      </p>
    </>
  );
};
export default ListStarted;
